import React from 'react';
import { Grid, Text, Box, MultiSelect } from '@mantine/core';
import { t } from 'i18next';

interface CategoryOption {
  value: string;
  label: string;
}

interface CategorySelectorProps {
  categories: CategoryOption[];
  selectedCategories: string[];
  onChange: (selected: string[]) => void;
  label?: string;
  disabled?: boolean;
}

export const CategorySelector: React.FC<CategorySelectorProps> = ({
  categories,
  selectedCategories,
  onChange,
  label,
  disabled = false,
}) => {
  return (
    <Grid align="center">
      <Grid.Col span={4}>
        <Text fw={600}>{label || t('graph.selectCategories')}</Text>
      </Grid.Col>
      <Grid.Col span={8}>
        <Box style={{ flex: 'initial' }}>
          <div style={{ position: 'relative', width: '100%', maxWidth: '250px' }} className="hide-pills">
            <style>
              {`
              .hide-pills .mantine-Pill-root {
                display: none !important;
              }
              `}
            </style>
            <MultiSelect
              data={categories}
              value={selectedCategories}
              onChange={onChange}
              placeholder={selectedCategories.length === 0 ? t('graph.selectCategoriesPlaceholder') : t('graph.categoriesSelected', { count: selectedCategories.length })}
              disabled={disabled}
              clearable
              searchable
              w="100%"
              maxDropdownHeight={200}
            />
          </div>
        </Box>
      </Grid.Col>
    </Grid>
  );
}; 